import { TIME_FRAME } from '../app/shared/constants/filters.constants';

export function formatDateToString(dateToString: Date | undefined): string {
  if (!dateToString) {
    return 'Date is undefined';
  }

  const date = new Date(dateToString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${year}/${month}/${day} ${hours}:${minutes}`;
}

export function formatDate(date: Date) {
  const newDate = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
    0,
  );
  return newDate;
}

export function computeThresholdDate(period: string): Date {
  const today = new Date();
  switch (period) {
    case TIME_FRAME.WEEK:
      return new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() - 7,
      );
    case TIME_FRAME.MONTH:
      return new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() - 30,
      );
    case TIME_FRAME.THREEMONTH:
      return new Date(
        today.getFullYear(),
        today.getMonth() - 3,
        today.getDate(),
      );
    case TIME_FRAME.SIXMONTH:
      return new Date(
        today.getFullYear(),
        today.getMonth() - 6,
        today.getDate(),
      );
    case TIME_FRAME.ONEYEAR:
      return new Date(
        today.getFullYear() - 1,
        today.getMonth(),
        today.getDate(),
      );
    default:
      return new Date(today.getFullYear(), today.getMonth(), today.getDate());
  }
}

export function extractDays(periodStr: string): number {
  // parseInt will read the leading integer and stop at the first non-digit
  const days = parseInt(periodStr, 10);

  if (isNaN(days)) {
    throw new Error(`Could not extract days from "${periodStr}"`);
  }

  return days;
}
